import { Button } from '@mui/material';
import '../styles/registration.scss';

export const RegistrationFinal = () => {

    const authorization = () => {
        window.location.href = "/authorization";
    }

    return (
        <div className="registration__final">
            <h3>Вы успешно зарегистрировались!</h3>
            <p className='registration__final__text'>На данный момент ваша учётная запись находится на модерации. 
                Мы уведомим вас, когда она будет проверена и активирована. 
                Обычно это занимает до 24 часов.</p>
            <Button variant='contained' onClick={() => authorization()}>Войти</Button>
        </div>
    )
}